import { api, SuperDutyError } from '@/api';
import { err, ok, Result } from 'neverthrow';

type ChangePasswordResetMutationError =
  | {
      type: 'TOKEN_EXPIRED';
    }
  | {
      type: 'PASSWORD_TOO_WEAK';
    }
  | {
      type: 'INVALID_TOKEN';
    }
  | {
      type: 'API_ERROR';
      error: SuperDutyError;
    };

export const changePasswordResetMutation = (token: number) => ({
  mutationFn: async (
    password: string
  ): Promise<Result<true, ChangePasswordResetMutationError>> => {
    try {
      await api.ResetForgotPassword(token, {
        newPassword: password,
      });

      return ok(true);
    } catch (error) {
      if (error instanceof SuperDutyError) {
        if (error.code === 'TOKEN_EXPIRED') {
          return err({ type: 'TOKEN_EXPIRED' });
        }

        if (error.code === 'PASSWORD_TOO_WEAK') {
          return err({ type: 'PASSWORD_TOO_WEAK' });
        }

        if (error.code === 'INVALID_TOKEN') {
          return err({ type: 'INVALID_TOKEN' });
        }
      }

      return err({ type: 'API_ERROR', error: error as SuperDutyError });
    }
  },
});
